import { put, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'
import router from '@Site/Router'

import Logger from '@Utils/Logger'

import {
  ISuccessResponse,
  IAction,
} from '@Root/types'

import {
  fetchWorkspacesSuccess,
  fetchWorkspacesFailure,
  renameAccountSuccess,
  renameAccountFailure,
  changeAvatarSuccess,
  changeAvatarFailure,
  changeTranslationProviderCredentialsSuccess,
  changeTranslationProviderCredentialsFailure,
  moveProjectsToOtherWorkspaceSuccess,
  moveProjectsToOtherWorkspaceFailure,
} from './actions'

import {
  setCurrentWorkspace
} from '@SiteModules/Workspace/actions'

import {
  IFetchWorkspacesPayload,
  IRenameAccountPayload,
  IFetchWorkspacesSuccessResponseBody,
  AccountActionTypes,
  IChangeAvatarPayload,
  IChangeTranslationProviderCredentialsPayload,
  IMoveProjectsToOtherWorkspacePayload,
} from './types'

import * as API from './api'

const SHORT_TIME_OUT = 2000 // msec

const call: any = Eff.call

function* fetchWorkspacesSaga(action: IAction<IFetchWorkspacesPayload>) {
  try {
    const response: ISuccessResponse<IFetchWorkspacesSuccessResponseBody> = yield call(API.fetchWorkspaces, action.payload)
    const payloadResponse: IFetchWorkspacesSuccessResponseBody = response.data
    yield put(fetchWorkspacesSuccess(payloadResponse))
  } catch (e) {
    Logger.error(e, 'Workspaces cannot be loaded')
    yield put(fetchWorkspacesFailure())
  }
}

function* renameAccountSaga(action: IAction<IRenameAccountPayload>) {
  try {
    yield call(API.renameAccount, action.payload)
    yield put(renameAccountSuccess(action.payload))
    toastr.success('', 'Account renamed')
  } catch (e) {
    Logger.error(e, 'Account cannot be renamed')
    yield put(renameAccountFailure())
  }
}

function* changeAvatarSaga(action: IAction<IChangeAvatarPayload>) {
  try {
    yield call(API.changeAvatar, action.payload)
    yield put(changeAvatarSuccess(action.payload))
    toastr.success('', 'Image changed')
  } catch (e) {
    Logger.error(e, 'Image cannot be changed')
    yield put(changeAvatarFailure())
  }
}

function* changeTranslationProviderCredentialsSaga(action: IAction<IChangeTranslationProviderCredentialsPayload>) {
  try {
    yield call(API.changeTranslationProviderCredentials, action.payload)
    yield put(changeTranslationProviderCredentialsSuccess(action.payload))
    if (action.payload.translationProviderId !== null || action.payload.translationProviderSecret !== null) {
      toastr.success('', 'Credentials changed')
    }
  } catch (e) {
    Logger.error(e, 'Credentials cannot be changed')
    yield put(changeTranslationProviderCredentialsFailure())
  }
}

function* moveProjectsToOtherWorkspaceSaga(action: IAction<IMoveProjectsToOtherWorkspacePayload>) {
  try {
    yield call(API.moveProjectsToOtherWorkspace, action.payload)
    yield put(moveProjectsToOtherWorkspaceSuccess())
    toastr.success('', 'Project(s) moved')
    yield put(setCurrentWorkspace({ workspaceId: action.payload.workspaceId }))

    setTimeout(() => {
      router.navigate('/')
    }, SHORT_TIME_OUT)
  } catch (e) {
    Logger.error(e, 'Project(s) could not be moved')
    yield put(moveProjectsToOtherWorkspaceFailure())
  }
}

function* accountsSagas() {
  yield takeLatest(AccountActionTypes.FETCH_WORKSPACES, fetchWorkspacesSaga)
  yield takeLatest(AccountActionTypes.RENAME_ACCOUNT, renameAccountSaga)
  yield takeLatest(AccountActionTypes.CHANGE_AVATAR, changeAvatarSaga)
  yield takeLatest(AccountActionTypes.CHANGE_TRANSLATION_PROVIDER_CREDENTIALS, changeTranslationProviderCredentialsSaga)
  yield takeLatest(AccountActionTypes.MOVE_PROJECTS_TO_OTHER_WORKSPACE, moveProjectsToOtherWorkspaceSaga)
}

export default accountsSagas
